import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import AppSettings from "../../../../Settings/AppSettings";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AuthManager from "../../../../Common/AuthManager";
import LoadingSuccessErrorAlert from "../../Rules/Components/LoadingSuccessErrorAlert";
import Label from "../../../Common/components/Label";
import { toast } from "react-toastify";
import GMSButton from "../../../Common/components/GMSButton";
import GMSFillButton from "../../../Common/components/GMSFillButton";
import { AppContext } from "../../../../Context/AppContext";
import { RULE_SUCCESS_MESSAGE } from "Components/GMS/Rules/Components/RuleConstants";

const Update = ({ modalUpdateClose, load_Products_By_Category, fromProduct = false, type = null, ruleId = null, display, fetchData }) => {
  const appData = useContext(AppContext);
  const channelKey = appData?.channelKey;
  const history = useHistory();
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [Loading, setLoading] = useState({ status: "", message: "", });
  const [suppressRule, setSuppressRule] = useState(false);
  const [selectedFile, setSelectedFile] = React.useState(null);
  const [inputKey, setInputKey] = useState("");
  const [psStatus, setPsStatus] = React.useState([]);

  // delete selected file
  async function handleFileDelete(event) {
    event.preventDefault();
    if (selectedFile != null) setSelectedFile(null);
  }

  const handleSuppressRuleCheck = (e) => {
    setSuppressRule(e.target.checked);
  };

  async function handle_file_selection(event) {
    event.preventDefault();
    const file = event.target.files[0];
    const totalCount = await appData.checkSelectedFile(file, file.type);
    if (totalCount > 0) {
      setSelectedFile(file);
    } else {
      setSelectedFile(null);
    }
  }

  const do_upload_pdw = async () => {
    try {
      setLoading({ status: "Loading", message: "File uploading....", });
      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("supress_rule", suppressRule);
      const url = type === "CBM" ? (display === 'values' ? `/rule/attribute_values/commit_rule/${ruleId}` : `rule/products/commit_rule/${ruleId}`) : `pdw/upload/updateproducts/${channelKey}`;
      const res = await ServiceWrapper.doPost(api_base_url + url, formData, null, AuthManager.getGmsToken(), true);

      if (!res.errorfound) {
        if (res.data.done === true) {
          setLoading({ status: "Loading", message: res.data.message, });
          setTimeout(() => {
            const jobId = type === "CBM" ? res.data.job_id : res.data.jobid;
            checkUploadStatus(jobId);
          }, 2000);
        } else {
          toast.error(res.data.message);
          setLoading({ status: "Error", message: res.data.message, });
        }
      } else {
        toast.error("Error while updating...");
        setLoading({ status: "Error", message: "Error Updating ", });
      }
      functionThatResetsTheFileInput();
      setSelectedFile(null);
    } catch (error) {
      console.error("constdo_upload_pdw= ~ error:", error)
    }
  }

  const checkUploadStatus = async (jobId) => {
    try {
      if (jobId) {
        const jobStatusResponse = await ServiceWrapper.doGet(api_base_url + "job/status/" + jobId, null, null, AuthManager.getGmsToken());

        if (!jobStatusResponse.errorfound) {
          if (jobStatusResponse.data.processing) {
            setLoading({ status: "Loading", message: jobStatusResponse.data.status });
            setTimeout(() => { checkUploadStatus(jobId); }, 2000);
            return;
          }

          if (jobStatusResponse.data.error) {
            toast.error(jobStatusResponse.data.status);
            setLoading({ status: "Error", message: jobStatusResponse.data.status });
            return;
          }

          if (fromProduct) {
            load_Products_By_Category();
          }
          if (type === 'CBM') {
            if (jobStatusResponse?.data?.message === RULE_SUCCESS_MESSAGE) {
              toast.success("Updated successfully");
              toast.success(
                <div className="tw-w-full">
                  <span className="tw-text-black tw-text-sm tw-font-semibold tw-font-['Noto Sans'] tw-leading-tight">
                    Committing in progress
                  </span>
                </div>,
                {
                  style: {
                    backgroundColor: "#e3fcef",
                  },
                }
              );
              history.push("/gms/rules/list");
            } else toast.success(jobStatusResponse?.data?.message);
            fetchData();
          } else {
            toast.success(jobStatusResponse.data.status);
          }
          setLoading({ status: "", message: "" });
          setTimeout(() => {
            modalUpdateClose();
          }, 2000);
        }
      } else {
        toast.error("Job Id not found");
        setLoading({ status: "Error", message: "JobId not found" });
      }
    } catch (error) {
      console.error("checkUploadStatus ~ error:", error)
    }
  }

  const functionThatResetsTheFileInput = () => {
    let randomString = Math.random().toString(36);
    setInputKey(randomString);
  };

  return (
    <div className="ps-0 pe-3">
      <div className="border p-5 cursor-pointer">
        <div>
          <label
            className="upload-area cursor-pointer"
            style={{
              width: "100%",
              textAlign: "center",
              color: "#091caa",
            }}
          >
            <input
              type="file"
              id="fupload"
              style={{ display: "none" }}
              key={inputKey || ""}
              onChange={(event) => handle_file_selection(event)}
              onClick={(event) => (event.target.value = null)}
            />
            <i className="fa fa-cloud-upload fa-x"></i>
            <br />

            <Label
              message="(Note: Only .xlsx files are allowed to upload)"
              fontSize={0.75}
              color={"#172B4D"}
            />
            <br />
            <strong>Browse File</strong>
          </label>
          <br />
          <span
            className="mt-2 w-100"
            style={{
              display: "block",
              width: "100%",
              textAlign: "center",
              wordWrap: "break-word",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {selectedFile && selectedFile.name}
          </span>
        </div>
      </div>
      {/* <div className="form-check mt-2">
        <input
          className="form-check-input"
          type="checkbox"
          id="checkSuppressRule"
          onChange={handleSuppressRuleCheck}
        />
        <label className="form-check-label" htmlFor="checkSuppressRule">
          Do not include these products until next rule synchronization
        </label>
      </div> */}

      <div className="d-flex mt-3 w-full justify-content-between">
        <GMSButton
          name="Delete"
          disabled={!selectedFile}
          className={
            "btn btn-outline-danger focus:outline-none active:scale-96 "
          }
          onClick={handleFileDelete}
        />

        <div className="d-flex">
          <GMSButton name="Cancel" onClick={() => modalUpdateClose()} />
          &nbsp;&nbsp;&nbsp;
          <GMSFillButton
            name="Save"
            disabled={!selectedFile}
            onClick={() => do_upload_pdw()}
          />
        </div>
      </div>
      <br />
      <br />
      <br />

      <div className="mt-2">
        <LoadingSuccessErrorAlert loading={Loading} hide_error={true} />
      </div>

      {psStatus.map((item, index) => (
        <React.Fragment key={index + "pdw_upload_sttaus"}>
          {item !== null && (
            <>
              <div className="alert alert-primary" role="alert">
                {index === psStatus.length - 1 && (
                  <span className="fas fa-circle-notch fa-spin" />
                )}
                {index !== psStatus.length - 1 && (
                  <span className="fas fa-check-circle" />
                )}
                &nbsp;
                {<strong>{item}</strong>}
              </div>
            </>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};
export default Update;